export const state = () => ({

	lang : "",			// 설정 언어
	langMap : {},		// 다국어 키/값 맵

});

export const mutations = {

	SET_LANG( state, lang ) {
		state.lang = lang;
	},

	SET_LANG_MAP( state, lang ) {
		state.langMap = lang;
	}

}

export const actions = {

	setLang( { commit }, lang )	{

		// this.$axios.post( url, param ).then( res => {
		//
		// });

		commit( "SET_LANG", lang );
	},

	setLangMap( { commit }, lang ) {
		commit( "SET_LANG_MAP", lang );
	}

}

export const getters = {

	getLang() {

	},

	getLangMap() {

	},

	getLangMapVal() {

	},

}
